var render = function render(){var _vm=this,_c=_vm._self._c;return _c('normal-popup',{attrs:{"width":"75%"}},[_c('div',{staticClass:"flexed justify-between",attrs:{"slot":"header"},slot:"header"},[_c('span',[_vm._v(_vm._s(_vm.$t('lbl_hotel_details')))]),_c('span',{staticClass:"close pointer",on:{"click":function($event){return _vm.$emit('close')}}},[_c('i',{staticClass:"el-icon-close"})])]),_c('hotel-details')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }